export const SportsCardPriceMultiplier = 1.3;

export const adjustSportsCardPrice = (price: number): number => {
  const adjustedPrice = price * SportsCardPriceMultiplier;
  if (adjustedPrice <= 100) return Math.ceil(adjustedPrice);
  if (adjustedPrice <= 500) return Math.ceil(adjustedPrice / 20) * 20;
  if (adjustedPrice <= 2000) return Math.ceil(adjustedPrice / 50) * 50;
  if (adjustedPrice <= 10_000) return Math.ceil(adjustedPrice / 100) * 100;
  return Math.ceil(adjustedPrice / 500) * 500;
};
